import { Arrays }	from "ts-base/arrays";

/** in contrast to Record, this does not pretend to contain a value for every key possible by the key type */
export type Table<K, V> = Readonly<{
	has:		(key:K)	=> boolean,
	get:		(key:K)	=> V,
	getOrNull:	(key:K)	=> V | null,
}>;

export namespace Table {
	export const build = <K extends number, V extends Record<PK, K>, PK extends keyof V>(name:string, values:ReadonlyArray<V>, pk:PK): Table<K, V> => {
		const map:Map<K, V>	= Arrays.singleKeyMap(values)(it => it[pk]);

		return {
			has: (key:K):boolean => map.has(key),
			get: (key:K):V => {
				if (!map.has(key))	throw new Error(`table ${name} does not contain key ${key}`);
				return map.get(key) as V;
			},
			getOrNull: (key:K): V | null => map.has(key) ? map.get(key) as V : null,
		};
	};

	export const empty = <K extends number, V>(name: string): Table<K, V> => ({
		has:		(_key:K) => false,
		get:		(key:K) => { throw new Error(`table ${name} does not contain key ${key}`); },
		getOrNull:	(_key:K) => null,
	});
}
